import { UserCog } from "lucide-react";
import { can, type SessionUser } from "../shared/auth/access";
import { workingRoleOptions, type WorkingRole } from "./navigation";

type Props = {
  user: SessionUser;
  rolePreview: boolean;
  switching: boolean;
  onSwitch: (role: WorkingRole) => Promise<void>;
  placement?: "header" | "production";
};

export function ActiveWorkingRoleSelector({ user, rolePreview, switching, onSwitch, placement = "header" }: Props) {
  if (rolePreview || user.preview || user.assignedRoles.length < 2 || !can(user, "session.manage.self")) return null;
  const options = workingRoleOptions.filter((option) => user.assignedRoles.includes(option.value));
  return (
    <label className={`active-role-selector${placement === "production" ? " production-working-role" : ""}`}>
      <UserCog size={15} aria-hidden="true" />
      <span>Aktif rol</span>
      <select aria-label="Aktif çalışma rolü" value={user.role} disabled={switching}
        onChange={(event) => {
          const role = options.find((option) => option.value === event.target.value)?.value;
          if (role && !switching) void onSwitch(role);
        }}>
        {options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
      </select>
    </label>
  );
}
